window.addEventListener('DOMContentLoaded', () => {
    var $carousel = $('.product-media-modal__content');

    $carousel.slick({
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: 1,
                    arrows: false
                }
            }
        ]
    });

    // remove keyup event listener for product-modal
    const $modal = $('#ProductModal-template--21624236900536__main');
    $modal.off();
});

